const isObserver = initAppData.isInWsContext && initAppData.currentWs.userRoles.indexOf('Observer') > -1;

const isWorkspaceMember = initAppData.isInWsContext && initAppData.currentWs.userRoles.indexOf('WorkspaceMember') > -1;

const isWorkspaceAdmin = initAppData.isInWsContext && initAppData.currentWs.userRoles.indexOf('WorkspaceAdmin') > -1;

const isSubscriptionAdmin = initAppData.isInWsContext && initAppData.currentWs.userRoles.indexOf('SubscriptionAdmin') > -1;

const isAdmin = isWorkspaceAdmin || isSubscriptionAdmin;

const canInviteMember = initAppData.isInWsContext && (isAdmin || initAppData.currentWs.canInviteMember);
const canInviteObserver = initAppData.isInWsContext && (isAdmin || initAppData.currentWs.canInviteObserver);
const canInvite = canInviteMember || canInviteObserver;

export const currentUserWsRoles = {
    isSubscriptionAdmin,
    isWorkspaceAdmin,
    isWorkspaceMember,
    isObserver,
    isAdmin,
    canInvite,
    canInviteMember,
    canInviteObserver,
};

export const hasStorymapAccess = () => {
    return initAppData.isInWsContext && initAppData.currentWs.hasStorymapAccess;
};

export const getStorymapRoleName = (role: StorymapRole) => {
    return role == StorymapRole.Viewer ? 'Viewer' : role == StorymapRole.Admin ? 'Admin' : 'Editor';
};

export const getWorkspaceRoleName = (role: WorkspaceRole) => {
    return role == WorkspaceRole.Observer
        ? 'Observer'
        : role == WorkspaceRole.WorkspaceMember
        ? 'Member'
        : role == WorkspaceRole.WorkspaceAdmin
        ? 'Workspace admin'
        : 'Subscription admin';
};

export enum WorkspaceRole {
    Observer = 0,
    WorkspaceMember = 1,
    WorkspaceAdmin = 2,
    SubscriptionAdmin = 3,
}

export enum RoadmapRole {
    Viewer = 10,
    Editor = 20,
}

export enum StorymapRole {
    Viewer = 100,
    Editor = 200,
    Admin = 300,
}
